import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Service ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" HAII만의 서비스 ")

import { computed, onMounted, ref } from "vue";
import { useDisplay } from "vuetify";

import { Swiper, SwiperSlide } from "swiper/vue";
import { Autoplay, Pagination } from "swiper";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { xs, sm, smAndDown, smAndUp } = useDisplay();

const services = ref([
  {
    title: "사회적 비용의 절감",
    content:
      "검사수행자에 의한 대면 선별비용 감축 및 맞춤형 치매 관리 연계 시 치매로 인한 사회적 비용의 절감 가능 합니다.",
    show: false,
  },
  {
    title: "어르신 친화적 UI 화면",
    content:
      "어르신들의 사용자 경험을 높일 수 있는 다양한 HCI 이론들에게 근거하여 디자인되었으며, 실 사용자의 사용성 평가에서 높은 점수를 받았습니다.",
    show: false,
  },
  {
    title: "암호화, 비 식별화를 통한 보안 확보",
    content:
      "개인의 검진 결과를 암호화, 비 식별화를 통해 개인 데이터가 안전하게 보관될 수 있도록 개발되었습니다. 개개인만이 각자의 결과를 확인할 수 있습니다.",
    show: false,
  },
  {
    title: "통합적인 프로그램 제공",
    content:
      "인지강화게임 뿐만 아니라, 시니어 생활 전반에 필요한 습관 형성과 AI 에이전트를 통해 유익한 대화를 제공합니다.",
    show: false,
  },
]);

const sliderCardTextHeight = ref(0);
const modules = ref([Autoplay, Pagination]);
const display = ref("inherit");

const getHeight = (id: string) => {
  const heightElement = document.getElementById(id);
  if (!heightElement) {
    return 0;
  }
  return heightElement.clientHeight;
};

const sliderPerView = computed(() => {
  if (xs.value) return 1.25;
  if (sm.value) return 2;
  return 3;
});

const spaceBetween = computed(() => {
  if (xs.value) return 25;
  return 40;
});

const cardWidth = computed(() => {
  if (xs.value) return "75vw";
  return "40vw";
});

onMounted(() => {
  setTimeout(() => {
    sliderCardTextHeight.value = getHeight("sliderCardText");
    display.value = "none";
  }, 300);
});

return (_ctx: any,_cache: any) => {
  const _component_v_card_subtitle = _resolveComponent("v-card-subtitle")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_expand_transition = _resolveComponent("v-expand-transition")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, { class: "elevation-0" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_subtitle, {
        class: _normalizeClass(["font-weight-regular", { 'text-subtitle-1': _unref(xs), 'text-h6': _unref(smAndUp) }]),
        style: {"color":"#0a6cff","opacity":"1"}
      }, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      }, 8, ["class"]),
      _createVNode(_component_v_card_title, {
        class: _normalizeClass(["font-weight-medium", { 'text-h5': _unref(xs) }]),
        style: {"font-size":"2.25rem"}
      }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      }, 8, ["class"]),
      _createVNode(_component_v_card_text, null, {
        default: _withCtx(() => [
          _createVNode(_unref(Swiper), {
            slidesPerView: _unref(sliderPerView),
            centeredSlides: true,
            spaceBetween: _unref(spaceBetween),
            modules: modules.value,
            pagination: {
          clickable: true,
        },
            class: "mySwiper"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(services.value, (service, index) => {
                return (_openBlock(), _createBlock(_unref(SwiperSlide), {
                  key: index,
                  class: "mb-5"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card, {
                      class: _normalizeClass(["mx-auto mt-3 mb-8 pa-3", { isShow: service.show }]),
                      width: _unref(cardWidth),
                      style: {"box-shadow":"0 2px 4px 0 #00000070"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card_title, {
                          class: _normalizeClass(["font-weight-bold justify-center", { 'text-subtitle-1': _unref(xs) }]),
                          style: {"word-break":"keep-all","min-height":"6rem","color":"#002049"}
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(service.title), 1)
                          ]),
                          _: 2
                        }, 1032, ["class"]),
                        _createVNode(_component_v_card_actions, { style: {"min-height":"0"} }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_expand_transition, null, {
                              default: _withCtx(() => [
                                _withDirectives(_createElementVNode("div", null, [
                                  _createVNode(_component_v_card_text, {
                                    class: _normalizeClass(["font-weight-medium", { 'text-body-2': _unref(xs), 'text-body-1': _unref(smAndUp) }]),
                                    style: _normalizeStyle([{"word-break":"keep-all","color":"#002049","display":"table-cell","vertical-align":"middle"}, { height: sliderCardTextHeight.value - 32 + 'px' }]),
                                    justify: "center"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(service.content), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["class", "style"])
                                ], 512), [
                                  [_vShow, service.show]
                                ])
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_v_btn, {
                          variant: "plain",
                          icon: service.show ? 'mdi-chevron-up' : 'mdi-chevron-down',
                          onClick: ($event: any) => (service.show = !service.show)
                        }, null, 8, ["icon", "onClick"])
                      ]),
                      _: 2
                    }, 1032, ["class", "width"])
                  ]),
                  _: 2
                }, 1024))
              }), 128)),
              _createVNode(_unref(SwiperSlide), {
                class: "mb-5",
                style: _normalizeStyle({ display: display.value })
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card, {
                    class: "mx-auto my-5 pa-3",
                    width: _unref(cardWidth)
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card_title, {
                        class: _normalizeClass(["font-weight-bold justify-center", { 'text-subtitle-1': _unref(xs) }]),
                        style: {"word-break":"keep-all","min-height":"4rem","color":"#002049"}
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(services.value[2].title), 1)
                        ]),
                        _: 1
                      }, 8, ["class"]),
                      _createVNode(_component_v_card_actions, { style: {"min-height":"0"} }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_expand_transition, null, {
                            default: _withCtx(() => [
                              _withDirectives(_createElementVNode("div", null, [
                                _createVNode(_component_v_card_text, {
                                  id: "sliderCardText",
                                  class: _normalizeClass(["font-weight-medium", { 'text-body-2': _unref(xs), 'text-body-1': _unref(smAndUp) }]),
                                  style: {"word-break":"keep-all","color":"#002049","display":"table-cell","vertical-align":"middle"}
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(services.value[2].content), 1)
                                  ]),
                                  _: 1
                                }, 8, ["class"])
                              ], 512), [
                                [_vShow, true]
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_btn, {
                        variant: "plain",
                        icon: "mdi-chevron-down"
                      })
                    ]),
                    _: 1
                  }, 8, ["width"])
                ]),
                _: 1
              }, 8, ["style"])
            ]),
            _: 1
          }, 8, ["slidesPerView", "spaceBetween", "modules"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})